// Page-address updates (query parameters). Built from the page's own URL, never as a relative '?…': that
// resolves against <base href="/m/_a/"> (the asset root, added by the Worker) and drops the page's own path.
// set: { key: value } sets, null/undefined removes; an empty value is written bare (?inside).
// WS-52: `q` is the host's (a scanned wayfinding code on a placement's address, worker/store.js QR_PARAM). The engine
// never reads it and no control owns it, and it is KEPT like every parameter the engine did not set: the host reads
// it again on a reload, so "you are here" is still there after one and after a place was pressed.
export function addressUrl(href, set = {}) {
  const u = new URL(href);
  for (const [k, v] of Object.entries(set)) { if (v == null) u.searchParams.delete(k); else u.searchParams.set(k, v); }
  u.search = u.searchParams.toString().replace(/=(?=&|$)/g, '');
  return u.href;
}
export const setAddress = (set) => history.replaceState(null, '', addressUrl(location.href, set));
